





























































































import { Component, Vue, Prop, Mixins, Ref, Watch } from 'vue-property-decorator';
import associationSearch from '@/views/sheet/components/associationSearch.vue';
import associationCard from '@/views/sheet/components/associationCard.vue';
import widgetCommon from './widgetCommon';
import { getSheetConfig, relevanceRecord } from '@/apis/sheet';
import widgetPop from './widgetPop';
import detailRecord from '@/views/sheet/detailRecord.vue';
import { getAssociationRecordSelect, deleteRecordBidirectional } from '@/apis/sheet';
import associationTimeAxis from '@/views/sheet/components/associationTimeAxis.vue';
@Component({
	components: {
		associationCard,
		associationSearch,
		associationTimeAxis,
	},
})
export default class extends Mixins(widgetCommon, widgetPop) {
	@Prop({ default: '' }) public recordId!: string;
	public workSheetObj: any = {};
	public get value() {
		let v = this.form[this.item.businessId] || [];
		return v.length ? '1' : '';
	}
	public get worksheetId() {
		return this.item.associationWorksheet.worksheetId;
	}
	public get titleField() {
		let { titleField = '', fieldMap = {} } = this.workSheetObj;
		return fieldMap[titleField];
	}
	//  展示按钮
	public get isShowBtn() {
		// 单选
		if (this.item.associationRecordCount === 1 && this.list.length >= 1) {
			return false;
		}
		if (this.disabled) {
			return false;
		}
		return true;
	}
	@Ref() private searchRef!: associationSearch;
	@Ref() private detailRecord!: detailRecord;
	private list: any[] = [];
	private get bidirectionalAssociation() {
		if (this.item.bidirectionalAssociationFlag === 1 && this.recordId) {
			return {
				associationTableBusinessId: this.item.businessId,
				currentTableRecordId: this.recordId,
				worksheetId: this.item.worksheetId,
			};
		}
		return null;
	}
	private get displayField() {
		let { displayField } = this.item;
		let { fieldMap = {}, isAdmin } = this.workSheetObj;
		return displayField
			.filter((businessId) => {
				if (!fieldMap[businessId]) {
					return false;
				}
				if (isAdmin) {
					return true;
				}
				let { fieldAuthority } = fieldMap[businessId];
				let { canRead } = fieldAuthority || {};
				return canRead;
			})
			.map((item) => {
				return fieldMap[item];
			});
	}
	@Watch('worksheetId', { immediate: true })
	public valueChange(value) {
		if (value) {
			this.getConfig(value);
		}
	}
	public async getAssociationRecordSelect(pageNumber?: number) {
		let { businessId, worksheetId } = this.item;
		const data = {
			worksheetId,
			associationTableBusinessId: businessId,
			recordId: this.recordId,
			// page: {
			//   pageNumber: pageNumber || 1,
			//   pageSize: 10
			// }
		};
		let res = await getAssociationRecordSelect(data);
		if (res.success) {
			this.list = res.data.records || [];
			// this.page.pageNumber = pageNumber || 1
			// this.page.total = res.data.page.total
		}
	}
	public async getConfig(sheetId) {
		if (this.type === 'record_insert') {
			return;
		}
		this.workSheetObj = {};
		let res = await getSheetConfig({
			worksheetId: sheetId,
			queryFieldType: 1,
			isQueryView: false,
			isNeedAuthority: true,
		});
		let obj = {};
		if (res.success) {
			(res.data.fields || []).forEach((item) => {
				obj[item.businessId] = item;
			});
			res.data.fieldMap = obj;
			this.workSheetObj = res.data;
		}
	}
	public mounted() {
		this.initField();
	}
	public initField() {
		this.form[this.item.businessId] = this.form[this.item.businessId] || [];
		if (this.state === 'add' || this.type === 'record_insert') {
			this.list = [];
		} else {
			this.getAssociationRecordSelect();
		}
	}
	private async remove(index) {
		if (this.bidirectionalAssociation) {
			await deleteRecordBidirectional({
				...this.bidirectionalAssociation,
				associationTableRecordIds: [this.list[index].id],
			});
		}
		this.list.splice(index, 1);
		this.form[this.item.businessId] = this.list.map((item) => {
			return item.id;
		});
		this.recordChange(this.list[0] || {});
	}
	private addRecord() {
		this.changeStatus(true);
		this.$nextTick(() => {
			this.detailRecord.initForm();
		});
	}
	private saveRecord(type, data) {
		this.changeStatus(false);
		if (type === 'add') {
			this.submit([data]);
			this.searchRef.close();
		}
	}
	private addAssociation() {
		this.searchRef.open();
	}
	private rowClick(id) {
		if (this.isReadOnly) {
			let {
				associationWorksheet: { applicationId, worksheetId },
				viewId,
			} = this.item;
			this.$router.push(`/association/${applicationId}/${worksheetId}/${viewId}/${id}`);
		}
	}
	private async submit(selected) {
		const ids = selected.map((item) => {
			return item.id;
		});
		if (this.bidirectionalAssociation) {
			await relevanceRecord({
				...this.bidirectionalAssociation,
				associationTableRecordIds: ids,
			});
		}
		this.list = this.list.concat(selected);
		this.form[this.item.businessId] = this.list.map((item) => {
			return item.id;
		});
		this.recordChange(this.list[0] || {});
	}
	private recordChange(data) {
		if (this.item.associationRecordCount === 1) {
			this.$emit('recordChange', this.item, data);
		}
	}
	private beforeCreate() {
		let components = this.$options.components as any;
		components.detailRecord = detailRecord;
	}
}
